// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useCallback, useState, useEffect, useMemo} from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import recaptcha from '/www/lum/pub/util/recaptcha.js';
import {get_path, ls_set} from '@pub/util.js';
import {LOCAL_STORAGE_KEYS} from '@pub/constants.js';
import {track} from '@pub/utils/analytics.js';
import {Button} from '@pub/comp/button/index.js';
import {Box} from '@pub/comp/box';
import {Text} from '@pub/comp/text';
import {Svg} from '@pub/comp/svg/index.js';
import {Form} from '@pub/comp/form';
import {ACTION, promo_code, ref_code} from './constants.js';
import {Auth_ctx, shorten_promo, shorten_ref} from './common.js';
import {meta as Signup_meta} from './signup.js';
import {meta as Signin_meta} from './signin.js';
import {meta as Reset_meta} from './reset.js';
import * as cns from './auth.module.less';

const ACTION_META = {
    [ACTION.SIGNIN]: Signin_meta,
    [ACTION.SIGNUP]: Signup_meta,
    [ACTION.RESET]: Reset_meta,
};

function Form_control({action}){
    const [submitted, set_submitted] = useState(false);
    const [token_required, set_token_required] = useState();
    const meta = ACTION_META[action];
    const Comp = meta.form_comp;
    const Alts_comp = meta.alts;
    const handle_success = useCallback(()=>set_submitted(true), []);
    const handle_submit = useCallback(form_data=>etask(function*(){
        try {
            yield meta.on_submit(form_data);
        } catch(e){
            if (e.code=='invalid_2fa')
                return void set_token_required('token_2fa');
            throw e;
        }
    }), [meta]);
    const auth_ctx_val = useMemo(()=>({token_required}), [token_required]);
    let content = null;
    if (submitted && meta.submitted_content)
        content = meta.submitted_content;
    else
    {
        content = <>
          <Form className="sa-form" submit_label={meta.submit_label}
            on_submit={handle_submit}
            submit_cn={cn(cns.submit, 'signup')}
            on_success={handle_success}>
            <Text.l h1 className={cns.title}>{meta.title}</Text.l>
            {!!meta.details&&<Text.xxs className={cns.details}>
              {meta.details}
            </Text.xxs>}
            <Auth_ctx.Provider value={auth_ctx_val}>
              <Comp/>
            </Auth_ctx.Provider>
            {!!meta.disclaimer &&
              <div className={cns.disclaimer}>
                {meta.disclaimer}
              </div>
            }
          </Form>
          {!ref_code&&!!Alts_comp&&<Alts_comp/>}
        </>;
    }
    return <Box className={cns.wrap} id="login_modal"
      data-testid="login_modal">
      <div className={cns.content_wrap}>
        {content}
      </div>
      {!!meta.nav_href&&<Button className={cns.nav} view="link"
        href={get_path(meta.nav_href)} size="s" test_id={meta.nav_test_id}>
        {meta.nav_label}
      </Button>}
    </Box>;
}

export function Auth({className, action=ACTION.SIGNIN}){
    useEffect(()=>{
        if (promo_code)
            ls_set(LOCAL_STORAGE_KEYS.signup_promo, shorten_promo(promo_code));
        if (ref_code)
            ls_set(LOCAL_STORAGE_KEYS.signup_ref, shorten_ref(ref_code));
        else
            ls_set(LOCAL_STORAGE_KEYS.signup_ref, '');
        recaptcha.load();
        return ()=>recaptcha.unload();
    }, []);
    useEffect(()=>void track(`${action}_page_view`), [action]);
    return <div className={cn(cns.root, className)}>
      <div className={cns.logo_wrap}>
        <Svg className={cns.logo} name="logo_bright_sdk" flexible/>
      </div>
      <Form_control action={action}/>
    </div>;
}
